import Image from 'next/image';

export default function FeatureScreenshot({ feature, className = '' }) {
    const hasScreenshot =
        feature.screenShot &&
        feature.screenShot !== 'TITLE_IMAGE_NOT_FOUND' &&
        ((typeof feature.screenShot === 'string' && feature.screenShot.trim() !== '') ||
            (typeof feature.screenShot === 'object' && Object.keys(feature.screenShot).length > 0));

    return (
        <div className={`relative min-h-[400px] w-full rounded-lg bg-fuschia-100 p-6 ${className}`}>
            {hasScreenshot ? (
                <Image
                    src={`/dA/${feature.inode}/screenShot`}
                    alt={feature.title}
                    quality={50}
                    fill
                    className="object-contain p-6"
                />
            ) : (
                <div className="flex h-full min-h-[352px] items-center justify-center">
                    <span className="text-lg font-medium text-fuschia-500">Coming soon</span>
                </div>
            )}
        </div>
    );
}
